export default __webpack_public_path__ + "static/media/118t.609956d1.jpg";